// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card {
  margin: auto;
  width: 96%;
  margin-top: 2%;
  margin-bottom: 3%;
}

.cople-row {
  background-color: antiquewhite;
}

mat-card.mat-card.mat-focus-indicator {
  box-shadow: 4px -3px 7px 4px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}

input {
  max-width: 100%;
  width: 100%;
  font-size: 13px;
  max-height: 35px;
  height: 35px;
  text-align: center;
  margin-top: 2px;
  border-radius: 7px;
  border-color: #6c757d;
  border-style: double;
  display: flex;
}

mat-grid-list {
  display: flex;
  direction: rtl;
}

mat-radio-group {
  display: flex;
  margin-right: auto;
}

:host ::ng-deep .mat-radio-label-content {
  padding-right: 10px;
}

button.mat-focus-indicator.button-accept.mat-button.mat-raised-button.mat-button-base.mat-primary {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
  margin-right: auto;
  margin-top: 15px;
  background-color: #2a8954;
  color: white;
  margin-left: 10px;
}

button.mat-focus-indicator.button-back.mat-button.mat-raised-button.mat-button-base.mat-primary {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
  margin-right: auto;
  margin-top: 15px;
}

::ng-deep .mat-grid-tile .mat-figure {
  align-items: flex-start !important;
  justify-content: right !important;
  margin-top: 15px !important;
  margin-right: 15px !important;
}

mat-radio-button {
  margin-left: 20px;
}

.buttons {
  float: left;
}

img {
  width: 100px;
  height: 100px;
}

.img2 {
  width: 400px;
  height: 400px;
}

.request-card {
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
  padding: 15px;
  border-radius: 5px;
  background-color: white;
  margin: 20px;
}
.request-card .right-side {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 20px;
  direction: rtl;
  text-align: right;
}
.request-card .right-side div {
  align-items: baseline;
  display: inline;
  padding: 10px;
}
.request-card .left-side {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-width: 25%;
  justify-content: center;
  display: flex;
  border-right: 4px dashed #eee;
}
.request-card .left-side div {
  display: inline;
}
.request-card .left-side div * {
  margin-right: 5px;
}

.item {
  margin: auto;
}

p {
  margin-top: 10px;
}

.text-item {
  font-size: 13px;
}

.btn {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 105px;
  border: 2px solid #eee;
}

.icon-card {
  margin: auto;
  margin-top: 1px;
  margin-left: 8px;
  font-size: 20px;
}

.field-header {
  margin-right: auto;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/features/verification-customer/verification-customer-info/verification-customer-info.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/verification-customer/verification-customer-info/verification-customer-info.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;ACCJ;;ADCE;EACE,8BAAA;ACEJ;;ADAE;EACE,yHAAA;ACGJ;;ADCE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;ACEJ;;ADCE;EACE,aAAA;EACA,cAAA;ACEJ;;ADCE;EACE,aAAA;EACA,kBAAA;ACEJ;;ADAE;EACE,mBAAA;ACGJ;;ADAE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;ACGJ;;ADDE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;ACIJ;;ADFE;EACE,kCAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;ACKJ;;ADHE;EACE,iBAAA;ACMJ;;ADJE;EACA,WAAA;ACOF;;ADLE;EACE,YAAA;EACA,aAAA;ACQJ;;ADNE;EACE,YAAA;EACA,aAAA;ACSJ;;ADLE;EACE,uGAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;ACQJ;ADPI;EAME,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;ACIN;ADfM;EACE,qBAAA;EACA,eAAA;EACA,aAAA;ACiBR;ADNI;EACE,cAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;ACQN;ADPM;EACE,eAAA;ACSR;ADRQ;EACE,iBAAA;ACUV;;ADLE;EAEE,YAAA;ACOJ;;ADJE;EACE,gBAAA;ACOJ;;ADLE;EACE,eAAA;ACQJ;;ADLE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;ACQJ;;ADNE;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACSF;;ADLE;EACE,kBAAA;EACA,iBAAA;ACQJ","sourcesContent":["mat-card {\r\n    margin: auto;\r\n    width: 96%;\r\n    margin-top: 2%;\r\n    margin-bottom: 3%;\r\n  }\r\n  .cople-row{\r\n    background-color: antiquewhite;\r\n  }\r\n  mat-card.mat-card.mat-focus-indicator {\r\n    box-shadow: 4px -3px 7px 4px rgb(0 0 0 / 20%),\r\n      0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);\r\n  }\r\n  \r\n  input {\r\n    max-width: 100%;\r\n    width: 100%;\r\n    font-size: 13px;\r\n    max-height: 35px;\r\n    height: 35px;\r\n    text-align: center;\r\n    margin-top: 2px;\r\n    border-radius: 7px;\r\n    border-color: #6c757d;\r\n    border-style: double;\r\n    display: flex;\r\n  }\r\n  \r\n  mat-grid-list {\r\n    display: flex;\r\n    direction: rtl;\r\n  }\r\n  \r\n  mat-radio-group {\r\n    display: flex;\r\n    margin-right: auto;\r\n  }\r\n  :host ::ng-deep .mat-radio-label-content {\r\n    padding-right: 10px;\r\n  }\r\n  \r\n  button.mat-focus-indicator.button-accept.mat-button.mat-raised-button.mat-button-base.mat-primary {\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 120px;\r\n    margin-right: auto;\r\n    margin-top: 15px;\r\n    background-color: #2a8954;\r\n    color: white;\r\n    margin-left: 10px;\r\n  }\r\n  button.mat-focus-indicator.button-back.mat-button.mat-raised-button.mat-button-base.mat-primary {\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 120px;\r\n    margin-right: auto;\r\n    margin-top: 15px;\r\n  }\r\n  ::ng-deep .mat-grid-tile .mat-figure {\r\n    align-items: flex-start !important;\r\n    justify-content: right !important;\r\n    margin-top: 15px !important;\r\n    margin-right: 15px !important;\r\n  }\r\n  mat-radio-button {\r\n    margin-left: 20px;\r\n  }\r\n  .buttons {\r\n  float: left;\r\n  }\r\n  img {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n  .img2{\r\n    width: 400px;\r\n    height: 400px;\r\n  }\r\n  \r\n  \r\n  .request-card {\r\n    box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px, rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n    padding: 15px;\r\n    border-radius: 5px;\r\n    background-color: white;\r\n    margin: 20px;\r\n    .right-side {\r\n      div {\r\n        align-items: baseline;\r\n        display: inline;\r\n        padding: 10px;\r\n      }\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      justify-content: space-between;\r\n      padding-left: 20px;\r\n      direction: rtl;\r\n      text-align: right;\r\n  \r\n    }\r\n    .left-side {\r\n      flex: 1 1 100%;\r\n      box-sizing: border-box;\r\n      max-width: 25%;\r\n      justify-content: center;\r\n      display: flex;\r\n      border-right: 4px dashed #eee;\r\n      div {\r\n        display: inline;\r\n        * {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .item {\r\n  \r\n    margin: auto;\r\n  }\r\n  \r\n  p{\r\n    margin-top: 10px;\r\n  }\r\n  .text-item{\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .btn{\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 105px;\r\n    border: 2px solid #eee;\r\n  }\r\n  .icon-card{\r\n  margin: auto;\r\n  margin-top: 1px;\r\n  margin-left: 8px;\r\n  font-size: 20px;\r\n  }\r\n  \r\n  \r\n  .field-header{\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n  }","mat-card {\n  margin: auto;\n  width: 96%;\n  margin-top: 2%;\n  margin-bottom: 3%;\n}\n\n.cople-row {\n  background-color: antiquewhite;\n}\n\nmat-card.mat-card.mat-focus-indicator {\n  box-shadow: 4px -3px 7px 4px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n}\n\ninput {\n  max-width: 100%;\n  width: 100%;\n  font-size: 13px;\n  max-height: 35px;\n  height: 35px;\n  text-align: center;\n  margin-top: 2px;\n  border-radius: 7px;\n  border-color: #6c757d;\n  border-style: double;\n  display: flex;\n}\n\nmat-grid-list {\n  display: flex;\n  direction: rtl;\n}\n\nmat-radio-group {\n  display: flex;\n  margin-right: auto;\n}\n\n:host ::ng-deep .mat-radio-label-content {\n  padding-right: 10px;\n}\n\nbutton.mat-focus-indicator.button-accept.mat-button.mat-raised-button.mat-button-base.mat-primary {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n  margin-right: auto;\n  margin-top: 15px;\n  background-color: #2a8954;\n  color: white;\n  margin-left: 10px;\n}\n\nbutton.mat-focus-indicator.button-back.mat-button.mat-raised-button.mat-button-base.mat-primary {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n  margin-right: auto;\n  margin-top: 15px;\n}\n\n::ng-deep .mat-grid-tile .mat-figure {\n  align-items: flex-start !important;\n  justify-content: right !important;\n  margin-top: 15px !important;\n  margin-right: 15px !important;\n}\n\nmat-radio-button {\n  margin-left: 20px;\n}\n\n.buttons {\n  float: left;\n}\n\nimg {\n  width: 100px;\n  height: 100px;\n}\n\n.img2 {\n  width: 400px;\n  height: 400px;\n}\n\n.request-card {\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n  padding: 15px;\n  border-radius: 5px;\n  background-color: white;\n  margin: 20px;\n}\n.request-card .right-side {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-left: 20px;\n  direction: rtl;\n  text-align: right;\n}\n.request-card .right-side div {\n  align-items: baseline;\n  display: inline;\n  padding: 10px;\n}\n.request-card .left-side {\n  flex: 1 1 100%;\n  box-sizing: border-box;\n  max-width: 25%;\n  justify-content: center;\n  display: flex;\n  border-right: 4px dashed #eee;\n}\n.request-card .left-side div {\n  display: inline;\n}\n.request-card .left-side div * {\n  margin-right: 5px;\n}\n\n.item {\n  margin: auto;\n}\n\np {\n  margin-top: 10px;\n}\n\n.text-item {\n  font-size: 13px;\n}\n\n.btn {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 105px;\n  border: 2px solid #eee;\n}\n\n.icon-card {\n  margin: auto;\n  margin-top: 1px;\n  margin-left: 8px;\n  font-size: 20px;\n}\n\n.field-header {\n  margin-right: auto;\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
